<script setup lang="ts">

import { CarbucksPromotion } from '@app/Carbucks/Promotion';
import type { ICarbucksProfile } from '@domain/Carbucks';
import LinkCardPromotionTile from "@app/Carbucks/Promotion/LinkCardPromotionTile.vue";

const model = defineModel<ICarbucksProfile>( { required: true } );
const emit = defineEmits( [ 'dismiss-promotion' ] );

</script>

<template>

    <div class="px-4 3xl:px-6 flex flex-col gap-2 3xl:gap-3">
    
        <h1 class="flex items-center justify-between tracking-wider text-base 3xl:text-xl">
            Before you get started
        </h1>

        <h2 class="-mt-2 tracking-wider text-sm 3xl:text-lg opacity-40">
            You need to link a card to earn cashback
        </h2>
        
        <div class="rounded-lg overflow-hidden">
            <LinkCardPromotionTile v-model="model" 
                                   :can-dismiss="false"
                                   :show-why-link-cta="true" />
        </div>

    </div>

</template>